// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3kWo0","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3Glnt"};